import { render, staticRenderFns } from "./Projects.vue?vue&type=template&id=19ab44c5&scoped=true&"
import script from "./Projects.vue?vue&type=script&lang=ts&"
export * from "./Projects.vue?vue&type=script&lang=ts&"
import style0 from "./Projects.vue?vue&type=style&index=0&id=19ab44c5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ab44c5",
  null
  
)

export default component.exports